<!--P026、P031、P113、P114-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">门店维护</div>
    </div>
    <!--查询栏-->
    <div class="cs_margin_top div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">门店</div>
      <input v-model="search.name" class="cs_input cs_radius_lg edtxt_info_search" style="width: 280px;" placeholder="请输入">
      <button class="ui_btn_search_yellow btn_search" type="button" @click="btnSearch">查询</button>
    </div>
    <!--表格-->
    <div class="cs_margin_top_sm div_search_result cs_padding_top_lg">
      <div class="div_operation_table">
        <button @click="btnAdd" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                 type="button">添加门店
        </button>
        <button @click="btnAddBatch" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                type="button">批量添加采购货品
        </button>
<!--        <button class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr cs_margin_left_sm"-->
<!--                type="button">删除-->
<!--        </button>-->
        <button v-show="isStop && isStopShow" @click="btnStart" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">启用
        </button>
        <button v-show="!isStop && isStopShow" @click="btnStop" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">停用
        </button>
      </div>
      <div class="cs_margin_top div_table">
        <table class="cs_table cs_td_divider_none" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="224px">门店编号</th>
            <th width="400px">门店名称</th>
            <th width="240px">品牌</th>
            <th width="175px">启用状态</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTr(item)">
            <td>{{index+1}}</td>
            <td><a @click.stop="$router.push({name:'ShopDetail', query: {id:item.id}})">{{item.shopNum}}</a></td>
            <td>{{item.shopName}}</td>
            <td>{{item.brandName}}</td>
            <td>{{SHOP_STATUS[item.stop]}}</td>
          </tr>
          <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="div_page_download">
        <!--上一页-->
        <button v-show="search.pagination>1" @click="showList(search.pagination < 2?1:search.pagination-1)"
                class="btn_page_up" type="button">
        </button>
        <button v-show="search.pagination<=1" class="btn_page_up_disable" type="button"></button>
        <div class="current_page">{{search.pagination}}</div>
        <div class="oblique_line">/</div>
        <div class="total_page">{{search.totalPage}}</div>
        <!--下一页-->
        <button v-show="search.pagination!==search.totalPage" @click="showList(search.pagination+1)" class="btn_page_down" type="button"></button>
        <button v-show="search.pagination===search.totalPage" class="btn_page_down_disable" type="button"></button>
        <div @click="jump()" class="type_page_jump">跳转至</div>
        <input v-model="search.pageJump" class="txt_page_jump" type="text"
               @keyup="checkPositiveInt($event)" @blur="search.pageJump=checkPositiveInt($event)">
      </div>
    </div>
    <div class="div_bottom"></div>
    <!--添加采购货品弹窗，默认隐藏-->
    <div v-if="isDialogPurchaseShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:414px;height:516px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">批量添加采购货品</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">货品</div>
          <search-select :options="dialogPurchase.materialSearchItems"
                         @option-key="updateMaterialNamePurchase"
                         v-model="dialogPurchase.materialName"
                         :search-fn="acquireMaterialItemPurchase"
                         class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_58"></search-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">规格</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_58">{{dialogPurchase.materialSpecs}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购单位</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_30">{{dialogPurchase.purchaseUnit}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购门店</div>
          <div class="cs_radius_lg txt_info_search width_108 ui_margin_left_30">{{shopPurchaseSelectedList.length}}</div>
          <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_xs">家</div>
          <button @click="btnShopPurchase" type="button" class="cs_btn ui_btn_blue cs_margin_left">编辑</button>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">默认供应商</div>
          <web-select :options="dialogPurchase.supplierList"
                      @option-key="updateSupplierPurchase"
                      v-model="dialogPurchase.supplierName"
                      class="cs_input cs_radius_lg edtxt_info_search width_246"></web-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购单价</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_30">{{dialogPurchase.unitPrice}}</div>
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogPurchase.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogMaterial">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmPurchaseDialog">确定</button>
        </div>
      </div>
    </div>
    <!--编辑采购门店弹窗，默认隐藏-->
    <div v-if="isDialogShopPurchaseShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:542px;height:622px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">编辑采购门店</div>
        </div>
        <div class="cs_margin_top_lg div_table">
          <table class="cs_table cs_thead_fixed cs_td_divider_none table_confirm" width="100%">
            <thead>
            <tr>
              <th width="44px">序号</th>
              <th width="128px">门店编号</th>
              <th width="100%">门店名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in shopPurchaseList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrPurchaseDialog(item)">
              <td width="44px">{{index+1}}</td>
              <td width="128px">{{item.shopNum}}</td>
              <td width="100%">{{item.shopName}}</td>
            </tr>
            <template v-if="PAGE_SIZE>shopPurchaseList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-shopPurchaseList.length)">
                <td width="44px"></td>
                <td width="128px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogShopPurchase">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmShopPurchaseDialog">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select"
  import {Page, PAGE_SIZE,SHOP_STATUS} from "../../assets/utils/constants"
  import StorageConst from "../../assets/utils/StorageConst";
  export default {
    name: "ShopManage",
    components: {WebSelect,SearchSelect},
    data: function () {
      return {
        isStopShow: false,
        isStop: false,
        search: {
          name: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.SHOP_MANAGE,"name", ""),
          pageJump: "",
          totalPage: "",
          pagination: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.SHOP_MANAGE,"pagination", 1)
        },
        orderList: [],
        selectedId: "",
        selectedName: "",
        PAGE_SIZE: PAGE_SIZE,
        SHOP_STATUS: SHOP_STATUS,
        isDialogPurchaseShow: false,
        dialogPurchase: {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          hintDialog: "",
          purchaseUnit: "",
          materialSpecs:"",
          supplierId: 0,
          supplierName: "",
          supplierList: [],
          unitPrice: ""
        },
        isDialogShopPurchaseShow: false,
        shopPurchaseList: [],
        shopPurchaseSelectedList: [],
      }
    },
    created: function () {
      this.showList(this.search.pagination);
    },
    mounted: function() {
    },
    methods: {
      showList(pagination) {
        this.selectedId = "";
        this.selectedName = "";
        this.isStop = false;
        this.isStopShow = false;
        this.$ajax.shop.listShop.bind(this)(this.search.name, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.search.totalPage = data.data.totalPage;
          this.search.pagination = data.data.pagination;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.orderList = list;
          this.setStoreItem(StorageConst.LOCAL_PAGE_LIST.SHOP_MANAGE, JSON.stringify(this.search));
        }, (data) => {
        }, true)
      },
      btnSearch(){
        this.showList(1);
      },
      jump() {
        if (!this.isEmpty(this.search.pageJump)) {
          if(this.search.pageJump>this.search.totalPage){
            this.showList(this.search.totalPage);
          }else {
            this.showList(this.search.pageJump);
          }
        }
      },
      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.orderList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.id;
          this.selectedName = item.shopName;
          this.isStop = item.stop;
          this.isStopShow = true;
        }else {
          this.selectedId = "";
          this.selectedName = "";
          this.isStop = false;
          this.isStopShow = false;
        }
      },
      btnStop(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$alert("确认停用门店"+this.selectedName+"吗？", (clickConfirm) => {
          if (clickConfirm) {
            this.$ajax.shop.stopShop.bind(this)(this.selectedId, true, (data) => {
              this.$toast("停用成功");
              this.showList(this.search.pagination);
            }, (data) => {
            }, true)
          }
        }, true);
      },
      btnStart(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$alert("确认启用门店"+this.selectedName+"吗？", (clickConfirm) => {
          if (clickConfirm) {
            this.$ajax.shop.stopShop.bind(this)(this.selectedId, false, (data) => {
              this.$toast("启用成功");
              this.showList(this.search.pagination);
            }, (data) => {
            }, true)
          }
        }, true);
      },
      btnDelete(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        // this.$ajax.shop.deleteKitchen.bind(this)(this.selectedId, (data) => {
        //   this.$toast("删除成功");
        //   this.isStop = false;
        //   this.isStopShow = false;
        //   this.showList(this.search.pagination);
        // }, (data) => {
        // }, true)
      },
      btnAdd(){
        this.$router.push({name:'ShopAdd'});
      },
      btnAddBatch(){
        this.isDialogPurchaseShow = true;
      },
      btnConfirmPurchaseDialog(){
        if (this.isEmpty(this.dialogPurchase.materialId)) {
          this.dialogPurchase.hintDialog = "请选中一个货品";
          return
        }
        if(this.shopPurchaseSelectedList.length<1){
          this.dialogPurchase.hintDialog = "请选择采购门店";
          return
        }
        if (this.isEmptySelect(this.dialogPurchase.supplierId)) {
          this.dialogPurchase.hintDialog = "请选择默认供应商";
          return
        }
        let shopIds=this.shopPurchaseSelectedList[0];
        for (let i = 1; i < this.shopPurchaseSelectedList.length; i++) {
          shopIds = shopIds + "," + this.shopPurchaseSelectedList[i];
        }
        this.$ajax.shop.batchAddPurchaseMaterial.bind(this)(this.dialogPurchase.materialId, this.dialogPurchase.supplierId, shopIds, (data) => {
          this.$toast("添加成功");
          this.showList(this.search.pagination);
          this.closeDialogMaterial();
        }, (data) => {
        }, true,this.showErrorMsgPurchase)
      },
      acquireMaterialItemPurchase(search) {
        this.$ajax.common.searchMaterial.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
              purchaseUnit: data.data[i].purchaseUnit,
              materialSpecs: data.data[i].materialSpecs,
            })
          }
          this.dialogPurchase.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialNamePurchase(key) {
        this.dialogPurchase.materialId = key;
        if(!this.isEmpty(key)){
          this.acquireSupplierListPurchase(key);
          for(let i=0;i<this.dialogPurchase.materialSearchItems.length;i++){
            if(this.dialogPurchase.materialSearchItems[i].key === key){
              this.dialogPurchase.purchaseUnit = this.dialogPurchase.materialSearchItems[i].purchaseUnit;
              this.dialogPurchase.materialSpecs = this.dialogPurchase.materialSearchItems[i].materialSpecs;
              return;
            }
          }
        }else {
          this.dialogPurchase.hintDialog = "";
          this.dialogPurchase.purchaseUnit = "";
          this.dialogPurchase.materialName = "";
          this.dialogPurchase.materialSpecs = "";
        }
      },
      acquireSupplierListPurchase(materialId){
        this.$ajax.common.listSupplierByMaterial.bind(this)(materialId,(data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].supplierNum +"  "+ data.data[i].supplierName,
              unitPrice: data.data[i].unitPrice,
            })
          }
          this.dialogPurchase.supplierList = array;
        }, (data) => {
        }, true)
      },
      updateSupplierPurchase(key) {
        this.dialogPurchase.supplierId = key;
        if(!this.isEmptySelect(key)){
          for(let i=0;i<this.dialogPurchase.supplierList.length;i++){
            if(this.dialogPurchase.supplierList[i].key === key){
              this.dialogPurchase.unitPrice = this.dialogPurchase.supplierList[i].unitPrice;
              return;
            }
          }
        }else {
          this.dialogPurchase.hintDialog = "";
          this.dialogPurchase.unitPrice = "";
        }
      },
      showErrorMsgPurchase: function (msg) {
        this.dialogPurchase.hintDialog = msg;
      },
      btnShopPurchase(){
        this.shopPurchaseSelectedList = [];
        //显示门店列表
        this.$ajax.common.listShop.bind(this)((data) => {
          let list = data.data;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.shopPurchaseList = list;
        }, (data) => {
        }, true);
        this.isDialogShopPurchaseShow = true;
      },
      btnSelectTableTrPurchaseDialog(item){
        let selectedStatus = item.isSelected;
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.shopPurchaseSelectedList.push(item.id);
        }else {
          for(let i=0;i<this.shopPurchaseSelectedList.length;i++){
            if(item.id===this.shopPurchaseSelectedList[i]){
              this.shopPurchaseSelectedList.splice(i, 1);
              return
            }
          }
        }
      },
      closeDialogShopPurchase(){
        this.shopPurchaseList = [];
        this.shopPurchaseSelectedList = [];
        this.isDialogShopPurchaseShow = false;
      },
      btnConfirmShopPurchaseDialog(){
        if(this.shopPurchaseSelectedList.length<1){
          this.$toast("请选择采购门店");
          return
        }
        this.shopPurchaseList = [];
        this.isDialogShopPurchaseShow = false;
      },
      closeDialogMaterial(){
        this.isDialogPurchaseShow= false;
        this.dialogPurchase= {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          hintDialog: "",
          purchaseUnit: "",
          materialSpecs:"",
          supplierId: 0,
          supplierName: "",
          supplierList: [],
          unitPrice: ""
        };
        this.isDialogShopPurchaseShow= false;
        this.shopPurchaseList= [];
        this.shopPurchaseSelectedList= [];
      },
    },
  }
</script>

<style scoped>
  .width_246{width: 246px;}
  .width_108{width: 108px;}
  .txt_hint_dialog{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #FFB54C;
    text-align: center;
  }
  .margin_top_12{margin-top: 12px;}
  .margin_left_18{margin-left: 18px;}
  .table_confirm tbody{max-height: 411px;}
</style>



// WEBPACK FOOTER //
// src/page/shop/ShopManage.vue